import type { CSSProperties } from 'react'
import { Avatar as DsAvatar } from '@digdir/designsystemet-react'

export type AvatarProps = {
  name: string
  initials?: string
  size?: 'sm' | 'md' | 'lg' | number
  color?: string
}

const palette = ['accent', 'info', 'success', 'aurora', 'warning', 'fjord'] as const

/** Preserve identity/size inputs; DS owns shape and theme-aware contrast pairs. */
export function Avatar({ name, initials, size = 'md', color }: AvatarProps) {
  const words = name.trim().split(/\s+/).filter(Boolean)
  const label = (initials ?? (words.slice(0, 2).map(word => word[0]).join('') || '?')).toUpperCase()
  const hash = name.split('').reduce((sum, character) => sum + character.charCodeAt(0), 0)
  const pixels = typeof size === 'number' ? size : { sm: 20, md: 26, lg: 36 }[size]
  const style = {
    '--dsc-avatar-size': `${pixels}px`,
    '--dsc-avatar-font-size': `${pixels * 0.42}px`,
    '--dsc-avatar-padding': '0px',
    ...(color ? { '--dsc-avatar-background': color } : {}),
  } as CSSProperties
  return <DsAvatar className="avatar" aria-label={name.trim() || label} data-color={palette[hash % palette.length]} style={style}>{label}</DsAvatar>
}
